import { baseUrl } from "../../utils/baseUrl";
import jwtInterceoptor from "../autorizacao/jwt-interceptor";

class ServicosAtribuicaoExterna {
    create(atribuicao) {
        return jwtInterceoptor.post(`${baseUrl}/atribuicaoMilhasExterna`, atribuicao)
    }
    listarTodos(){
        return jwtInterceoptor.get(`${baseUrl}/atribuicaoMilhasExterna`)
    }
    editar(id, atribuicao){
        return jwtInterceoptor.put(`${baseUrl}/atribuicaoMilhasExterna/${id}`, atribuicao)
    }
    deletar(id){
        return jwtInterceoptor.delete(`${baseUrl}/atribuicaoMilhasExterna/${id}`)
    }
    listarPorIdColaborador(id){
        return jwtInterceoptor.get(`${baseUrl}/atribuicaoMilhasExterna/listaId/${id}`)
    }
}

export default new ServicosAtribuicaoExterna();